import script from "./AppointmentsAccessCodesTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentsAccessCodesTableRow.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__